import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ConnectivityService } from 'src/app/core/services/connectivity.service';

/**
 * Strip under the header that tells the user about the connection (see ConnectivityService): no network,
 * live updates gone, or connection back again.
 */
@Component({
    selector: 'app-connection-banner',
    templateUrl: './connection-banner.component.html',
    styleUrls: ['./connection-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe],
})
export class ConnectionBannerComponent {
  readonly connectivity = inject(ConnectivityService);
  readonly banner = this.connectivity.banner;

  reload(): void {
    window.location.reload();
  }
}
